// Created By - Sajin S Kumar
// Date - 25-11-2024
// Pupose - Airline form - >Master settings ->General settings

import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import { IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CustomModal from "../../../../../../../components/custom_modal/CustomModal";
import CustomTextField from "../../../../../../../components/custom_text_field/CustomTextField";
import CustomAutoCompleteDropdown from "../../../../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import "./airlineFormStyle.css";
import {
  create_new_serviceCharges,
  update_serviceCharges_by_id,
  get_serviceCharges_by_id,
} from "../../../../../../../api/generalSettingApis";
import { ErrorToast, SuccessToast } from "../../../../../../../toast/toasts";
import { get_ecr_serviceList } from "../../../../../../../api/commonLookUpApis";
import { get_services_list } from "../../../../../../../api/servicesApis";

function ServiceChargeForm({ open, handleClose, serviceCharges_id }) {
  const [serviceList, setServiceList] = useState([]);

  const [statusList, setStatusList] = useState([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  useEffect(() => {
    if (serviceCharges_id) {
      get_serviceCharges_by_id(serviceCharges_id)
        .then((response) => {

          const { charge, gst_rate, sac_code, service_id, status } = response?.data?.data;

          formik.setValues({
            ...formik.values,
            service_id: service_id,
            charge: charge,
            gst_rate: gst_rate,
            sac_code: sac_code,
            status: status,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getserviceList();
  }, [serviceCharges_id]);

  const formik = useFormik({
    initialValues: {
      service_id: "",
      charge: "",
      gst_rate: "",
      sac_code: "",
      status: 1,
    },
    validationSchema: Yup.object({
      charge: Yup.string().required("Charge is required"),
      gst_rate: Yup.string().required("GST Rate is required"),
      sac_code: Yup.string().required("SAC Code is required"),
      service_id: Yup.string().required("Service is required"),
      // status: Yup.string().required("Status is required"),
    }),

    onSubmit: (values) => {
      if (serviceCharges_id) {
        values["id"] = serviceCharges_id;
        update_serviceCharges_by_id(values)
          .then((response) => {
            if (response?.data?.status) {
              SuccessToast(response?.data?.message);
              handleClose(false);
            } else {
              ErrorToast(response?.data?.message);
            }
          })
          .catch((error) => {
            ErrorToast(error?.data?.message);
            console.log(error);
          });
      } else {
        create_new_serviceCharges(values)
          .then((response) => {            
            if (response?.data?.status) {
              SuccessToast(response?.data?.message);
              handleClose(false);
            } else {
              ErrorToast(response?.data?.message);
            }
          })
          .catch((error) => {
            ErrorToast(error?.data?.message);
            console.log(error);
          });
      }
    },
  });

  const getserviceList = () => {
    get_services_list()
      .then((response) => {
        const data = response?.data?.data?.map((item) => {
          return {
            label: item.ES_services_name,
            value: item.ES_id,
          };
        });

        setServiceList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <CustomModal
      maxWidth={"500px"}
      open={open}
      handleClose={handleClose}
      close={
        <IconButton
          aria-label="close"
          onClick={() => {
            handleClose(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <IoIosCloseCircleOutline />
        </IconButton>
      }
      title={
        serviceCharges_id
          ? "Update Service Charge"
          : "Create New Service Charge"
      }
      body={
        <div>
          <form id="alirline_form" onSubmit={formik.handleSubmit}>
            <div>
              <p className="airline_form_label">
                Charge<span className="label_required_remark">*</span>
              </p>
              <CustomTextField
                autoFocus
                // isDisabled={isView}
                name="charge"
                placeholder={"Enter Charge"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.charge}
                error={formik.touched.charge && Boolean(formik.errors.charge)}
                helperText={formik.touched.charge && formik.errors.charge}
              />
            </div>
            <div>
              <p className="airline_form_label">
                GST Rate<span className="label_required_remark">*</span>
              </p>
              <CustomTextField
                // isDisabled={isView}
                name="gst_rate"
                placeholder={"Enter GST Rate"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.gst_rate}
                error={
                  formik.touched.gst_rate && Boolean(formik.errors.gst_rate)
                }
                helperText={formik.touched.gst_rate && formik.errors.gst_rate}
              />
            </div>
            <div>
              <p className="airline_form_label">
                SAC Code<span className="label_required_remark">*</span>
              </p>
              <CustomTextField
                autoFocus
                // isDisabled={isView}
                name="sac_code"
                placeholder={"Enter SAC Code"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.sac_code}
                error={
                  formik.touched.sac_code && Boolean(formik.errors.sac_code)
                }
                helperText={formik.touched.sac_code && formik.errors.sac_code}
              />
            </div>
            <div>
              <p className="airline_form_label">
                Service<span className="label_required_remark">*</span>
              </p>
              <CustomAutoCompleteDropdown
                isDisabled={serviceCharges_id}
                name="serviceList"
                placeholder={"Select a Service"}
                options={serviceList}
                onChange={(_, newValue) => {
                  formik.setFieldValue(
                    "service_id",
                    newValue ? newValue.value : ""
                  );
                }}
                onBlur={formik.handleBlur}
                value={
                  serviceList.find(
                    (type) => type.value == formik.values.service_id
                  ) || null
                }
                error={
                  formik.touched.service_id && Boolean(formik.errors.service_id)
                }
                helperText={
                  formik.touched.service_id && formik.errors.service_id
                }
              />
            </div>
            <div>
              <p className="airline_form_label">
                Status<span className="label_required_remark">*</span>
              </p>
              <CustomAutoCompleteDropdown
                name="status"
                placeholder={"Select a Status"}
                options={statusList}
                onChange={(_, newValue) => {
                  formik.setFieldValue(
                    "status",
                    newValue ? newValue.value : ""
                  );
                }}
                onBlur={formik.handleBlur}
                value={
                  statusList.find(
                    (type) => type.value == formik.values.status
                  ) || null
                }
                error={formik.touched.status && Boolean(formik.errors.status)}
                helperText={formik.touched.status && formik.errors.status}
              />
            </div>
            <div>
              <div className="airline_modal_form_single_row_alignment">
                <button
                  className="airline_modal_form_reset_button"
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="airline_modal_form_submit_button"
                  type="submit"
                  form="alirline_form"
                >
                  {serviceCharges_id ? "Update" : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      }
    />
  );
}

export default ServiceChargeForm;
